import { CheckCircle2, AlertCircle, Info, Loader2, X } from 'lucide-react'
import { useToastStore, type ToastKind } from '../stores/toast'

const ICONS: Record<ToastKind, typeof CheckCircle2> = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
  loading: Loader2,
}

const STYLES: Record<ToastKind, string> = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  loading: 'bg-gray-50 border-gray-200 text-gray-700',
}

const ICON_COLORS: Record<ToastKind, string> = {
  success: 'text-green-600',
  error: 'text-red-600',
  info: 'text-blue-600',
  loading: 'text-gray-500',
}

export default function ToastContainer() {
  const { toasts, dismiss } = useToastStore()

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => {
        const Icon = ICONS[t.kind]
        return (
          <div
            key={t.id}
            className={`pointer-events-auto flex items-center gap-2 px-4 py-2.5 rounded-lg border shadow-md min-w-[260px] max-w-[420px] ${STYLES[t.kind]}`}
            role="alert"
          >
            <Icon className={`w-4 h-4 flex-shrink-0 ${ICON_COLORS[t.kind]} ${t.kind === 'loading' ? 'animate-spin' : ''}`} />
            <span className="text-sm flex-1">{t.message}</span>
            {t.kind !== 'loading' && (
              <button
                onClick={() => dismiss(t.id)}
                className="text-gray-400 hover:text-gray-600 flex-shrink-0"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        )
      })}
    </div>
  )
}
